var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVizparolaInactiv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.812,
    height: 14.139,
    viewBox: "0 0 18.812 14.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icoana-vizparola-inactiv",
    transform: "translate(-308.57 -307.633)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M322.775,311.1c2.356,1.545,4.107,3.63,4.107,3.963v.331c0,.539-4.589,5.669-8.907,5.669a8.22,8.22,0,0,1-3.87-1.147",
    fill: "none",
    stroke: "#7e858b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M312.042,318.541a10.631,10.631,0,0,1-2.972-3.145v-.331c0-.539,4.589-5.669,8.9-5.669a7.146,7.146,0,0,1,2.614.549",
    fill: "none",
    stroke: "#7e858b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M321.445,312.766a4.318,4.318,0,0,1-6.019,6.055",
    fill: "none",
    stroke: "#7e858b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M313.871,316.679a4.321,4.321,0,0,1,5.565-5.407",
    fill: "none",
    stroke: "#7e858b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_14",
    "data-name": "Ellipse 14",
    cx: 0.541,
    cy: 0.541,
    r: 0.541,
    transform: "translate(316.085 313.444)",
    fill: "#7e858b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M318.906,314.464l-1.8,1.8a1.267,1.267,0,0,0,.934.416,1.281,1.281,0,0,0,1.281-1.28A1.268,1.268,0,0,0,318.906,314.464Z",
    fill: "#7e858b"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    x1: 12.717,
    y2: 12.724,
    transform: "translate(311.248 308.34)",
    fill: "none",
    stroke: "#7e858b",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVizparolaInactiv);
export default __webpack_public_path__ + "static/media/icon-vizparola-inactiv.1b57096e4af5003688838249de8a6fbb.svg";
export { ForwardRef as ReactComponent };